export default __webpack_public_path__ + "static/media/Social-Twitter-Black.9a84301e.svg";